import Const from 'const';
import {generateSignature} from 'helpers/hash';
import {RuleItem} from 'components/organisms/projection-boost-rule/rule-item';
import {BoostStatementInterface, RuleItemInterface} from 'src/components/organisms/projection-boost-rule/interfaces';

const defaultStateData = {
    ruleItems: {},
};

const defaultState = {
    data: cp(defaultStateData),
    enabled: true,
    signature: generateSignature(),
    getDataToSaveInStorage() {
        const ruleItems = this.getItems().map((item) => {
            const boostStatements = item.getBoostStatements().map((boostStatement) => boostStatement.getData());

            return {...item.getData(), boostStatements};
        });

        return {ruleItems};
    },
    isEnabled(): boolean {
        return Boolean(this.enabled);
    },
    getItems(): RuleItemInterface[] {
        return Object.values(this.data.ruleItems);
    },
    hasItems(): boolean {
        return !isEmpty(this.data.ruleItems);
    },
    getItem(itemId): RuleItemInterface {
        return this.data.ruleItems[itemId];
    },
    getStatement(statementId): BoostStatementInterface | null {
        for (const ruleItem of this.getItems()) {
            for (const boostStatement of ruleItem.getBoostStatements()) {
                if (boostStatement.getId() === statementId) {
                    return boostStatement;
                }
            }
        }

        return null;
    },
    getSignature(): string {
        return this.signature;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.PROJECTION_BOOST_RULE_SET_DATA_FROM_STORAGE) {
        const {ruleItems} = action.data;

        Object.values(ruleItems).map((ruleItemDataStruct) => {
            // @ts-ignore
            const ruleItem = new RuleItem(cp(ruleItemDataStruct));

            state.data.ruleItems[ruleItem.getId()] = ruleItem;
        });
    } else if (action.type === Const.PROJECTION_BOOST_RULE_SET_IS_USED) {
        state.enabled = Boolean(action.use);
    } else if (action.type === Const.PROJECTION_BOOST_RULE_ADD_ITEM) {
        const {item} = action;
        state.data.ruleItems[item.getId()] = item;
    } else if (action.type === Const.PROJECTION_BOOST_RULE_REMOVE_ITEM) {
        delete state.data.ruleItems[action.itemId];
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: cp(defaultStateData),
            enabled: true,
            signature: generateSignature(),
        };
    }

    return state;
}
